<template>
  <md-card class="card-content">
    <md-card-content>
      <div class="md-layout" v-if="detail.length">
        <div class="md-layout-item md-size-100 my-4 mb-8 md-layout p-0">
          <div
            class="md-layout-item md-size-20"
            v-for="(item, title) in percentStudent"
            :key="'box' + title"
          >
            <result-box-custom
              class="h-full"
              :numberStudent="
                `${item.number_student} (${item.percent_student}%)`
              "
              :title="title"
            ></result-box-custom>
          </div>
        </div>
        <md-table class="w-full overflow-auto">
          <md-table-row>
            <md-table-head class="w-1/3">
              <span class="text-left text-[#333] font-medium">{{
                $t("common.student")
              }}</span>
            </md-table-head>
            <md-table-head class="w-1/3">
              <span class="text-left text-[#333] font-medium">{{
                $t("common.status")
              }}</span>
            </md-table-head>
            <md-table-head>
              <span class="text-left text-[#333] font-medium">{{
                $t("smi_sri.comment")
              }}</span>
            </md-table-head>
          </md-table-row>
          <md-table-row
            v-for="(item, index) in detail"
            :key="index + 'meta_data'"
          >
            <md-table-cell class="border-none p-0" colspan="3">
              <md-list class="py-[3px]">
                <md-list-item
                  md-expand
                  class="bg-[#EEEEEE] cursor-pointer rounded-lg"
                >
                  <div class="  flex justify-between items-center  w-full">
                    <div>
                      <div class="flex w-full pb-1 font-medium">
                        <div class="pr-2">
                          {{ convertDate(item[1].date) }} 
                        </div>
                        <div>
                          - {{ item[1].present_student }}/{{
                            item[1].total_student
                          }}
                        </div>
                      </div>
                      <div class="whitespace-pre-line">
                        {{ item[1].comment }}
                      </div>
                    </div>
                  </div>
                  <md-list slot="md-expand">
                    <md-list-item class="md-inset">
                      <md-table class="w-full">
                        <md-table-row
                          v-for="(attendance, index) in item[1].attendance"
                          :key="index + 'user_id'"
                        >
                          <md-table-cell class="w-1/3">
                            <div class="flex items-center gap-2">
                              <img
                                class="rounded-full mr-4 w-12 h-12"
                                :src="
                                  attendance.user_no_sql.avatar_url ||
                                    '/img/avt_placeholder.jpg'
                                "
                                alt="Avatar"
                              />
                              <p class="text-sm text-[#333] w-max">
                                {{ attendance.user_no_sql.full_name }}
                              </p>
                            </div>
                          </md-table-cell>
                          <md-table-cell class="py-1 w-1/3">
                            <div
                              :style="{
                                'background-color': setBgColorAttendanceStatus(
                                  attendance.status
                                )
                              }"
                              class="status-cell w-1/2 py-2"
                            >
                              <span
                                :style="{
                                  color: setColorAttendanceStatus(
                                    attendance.status
                                  ),
                                  'font-weight': 'bold'
                                }"
                              >
                                {{ generateStatus(attendance.status) }}
                              </span>
                            </div></md-table-cell
                          >
                          <md-table-cell
                            class="whitespace-pre-line leading-6 break-normal py-1 w-1/3"
                          >
                            {{ attendance.description }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table></md-list-item
                    >
                  </md-list>
                </md-list-item>
              </md-list>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div v-else>
        <no-data-found></no-data-found>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import ResultBoxCustom from "../../../Report/Attendance/ByClass/ResultBoxCustom";
import { generateStatus } from "../../../../helpers/text-helper";
import {
  setBgColorAttendanceStatus,
  setColorAttendanceStatus
} from "../../../../helpers/color";
import moment from "moment";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";
import { mapGetters } from "vuex";
import { formatDateClient } from "@/helpers/datetime-helper";

export default {
  props: ["percentStudent", "detail"],
  components: {
    ResultBoxCustom
  },
  data() {
    return {
      generateStatus,
      setBgColorAttendanceStatus,
      setColorAttendanceStatus,
      formatDateClient,
      moment
    };
  },
  computed: {
    ...mapGetters("user", {
      userTz: "timezone"
    })
  },
  methods: {
    formatDateTime(date, userTimeZone) {
      return convertTimeByTimezone(
        date,
        "Etc/UTC",
        userTimeZone ?? moment.tz.guess(),
        formatDateClient
      );
    },
    convertDate(item) {
      return this.formatDateTime(item, this.userTz);
    }
  }
};
</script>
<style scoped>
.status-cell {
  text-align: center;
  padding: 4px 8px;
  border-radius: 16px;
}
::v-deep .md-inset .md-list-item-container .md-ripple {
  padding: 0;
}
.md-list-item-expand {
  border-top: none;
  border-bottom: none;
}
</style>
